/**
 * Declerations
 */
export const orderboxmixins = {
    computed : {
        /**
         * Get flavors from indexed db
         */
        flavors() {
            return this.$store.state.flavors
        }
    },
    methods : {
         /**
         * Subscription order grouping
         * Group all order by box type and flavors
         */
        groupboxorder(orderboxes) {
            let order = [];

                orderboxes.forEach((box) => {

                const flavors    = [...new Set(box.flavors.slice())];
                const exist      = order.find(o => o.id == box.box_id && o.flavors.sort((a, b) => a.id - b.id).every((f, i) => f.id === flavors.sort((a, b) => a.id - b.id)[i].id));
                if(exist) {
                    exist.count++
                } else {
                    order = [...order, {
                        count      : 1,
                        id         : box.box_id,
                        box_name   : box.box_name,
                        flavors    : flavors,
                        flavorsname: box.flavors ? box.flavors.filter((value, index, self) => index === self.findIndex((t) => t.id === value.id)): []
                    }]
                }
            });


            return order;

        }
    }
}